import { Box, Card, CardMedia, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { collection, onSnapshot } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";

const EventSponsors = ({ eventDocId }) => {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.down("lg"));
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));


  // useEffect(() => {

  //   if (!eventDocId) return;

  //   const fetchSponsors = async () => {
  //     try {
  //       const sponsorsRef = collection(db, `events/${eventDocId}/sponsors`);
  //       const snapshot = await getDocs(sponsorsRef);
  //       const sponsorsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  //       setSponsors(sponsorsData);
  //     } catch (error) {
  //       console.error("Error fetching sponsors:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (eventDocId) {
  //     fetchSponsors();
  //   }

  // }, [eventDocId]);

  useEffect(() => {
    if (!eventDocId) return;

    const sponsorsRef = collection(db, "events", eventDocId, "sponsors");

    const unsubscribe = onSnapshot(sponsorsRef, (snapshot) => {
      const updatedSponsors = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSponsors(updatedSponsors);
    });

    // 🔄 Cleanup on unmount
    return () => unsubscribe();
  }, [eventDocId]);

  // if (loading) return <p>Loading sponsors...</p>;
  if (sponsors.length === 0) return <p>No sponsors available for this event.</p>;

  return (
    <Box sx={{ p: 3, maxWidth: "1200px", margin: "auto", textAlign: "center", }}>
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        Our Sponsors
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ mt: 2, mb: 4 }}>
        Join our successful sponsors. Show of your brand along with successful business.
      </Typography>
      {/* <Button variant="contained" color="primary" size="large">
              Join
            </Button>             */}

      <Grid container spacing={3}>
        {sponsors.map((sponsor) => (
          <Grid item size={{ xs: 6, sm: 4, md: 3 }} key={sponsor.id} alignItems="center" >

            <Card elevation={0} sx={{ bgcolor: "grey.100", alignItems: "center", p: 4, borderRadius: 3, }}>
              {/* <CardActionArea> */}
              <CardMedia
                component="img"
                width="10"
                image={sponsor.sponsorLogo}
                alt={sponsor.sponsorName}
              />
              {/* <CardContent>                   */}
              {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}> */}
              {/* {sponsor.sponsorName}  */}
              {/* </Typography> */}
              {/* </CardContent> */}
              {/* </CardActionArea> */}
            </Card>
          </Grid>
        ))}
      </Grid>

    </Box>
  );
};

export default EventSponsors;



